export let teamListProps = {
    key: 0,
    id: 0,
    staff_id: null,
    team_leader: false
}

export let dataProps = {
    team_id: null, 
    store_id: null,
    team_list: [JSON.parse(JSON.stringify(teamListProps))],
    deleted_team_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/teamList/properties.js